var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Not_Started"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Not_Started",
    "data-name": "Not Started",
    clipPath: "url(#clip-Not_Started)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_623",
    "data-name": "Ellipse 623",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(1 1)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_51",
    "data-name": "Subtraction 51",
    d: "M5,10a5,5,0,1,1,5-5A5.006,5.006,0,0,1,5,10Zm-2.1-5.5a.5.5,0,0,0,0,1H7.118a.5.5,0,0,0,0-1Z",
    transform: "translate(5 5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotStarted);
export default __webpack_public_path__ + "static/media/Not Started.7bcb5a14a3ab26e15d5da64e7e3a8dd7.svg";
export { ForwardRef as ReactComponent };